import { render } from "./TextControl.vue?vue&type=template&id=1f0543ba&scoped=true"
import script from "./TextControl.vue?vue&type=script&lang=js"
export * from "./TextControl.vue?vue&type=script&lang=js"

import "./TextControl.vue?vue&type=style&index=0&id=1f0543ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0543ba"]])

export default __exports__